import { useEffect, useRef } from 'react';

export function useInterval(callback: () => void, delay: number | null) {
    const savedCallback = useRef(callback);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        if (delay === null) return undefined;

        const thick = () => {
            if (savedCallback.current) savedCallback.current();
        }

        const id = setInterval(thick, delay);
        return () => clearInterval(id);
    }, [delay]);
} 